import i18n from 'i18n'
import { lowerCase, startCase } from 'lodash'
import { OrderDirection } from '../store/spot/types'

export function getOrderSide(
  direction: OrderDirection,
  format: 'startCase' | 'lowerCase' = 'startCase'
) {
  const buy = i18n.t('user-order-table-content-buy')
  const sell = i18n.t('user-order-table-content-sell')

  switch (format) {
    case 'lowerCase':
      return direction === OrderDirection.LONG
        ? lowerCase(buy)
        : lowerCase(sell)
    case 'startCase':
    default:
      return direction === OrderDirection.LONG
        ? startCase(buy)
        : startCase(sell)
  }
}
